
function setTransmissionDetails(state, details) {
	state.outboundTransmission = details;
}

export default { setTransmissionDetails };